import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const programs = [
  {
    title: 'TNO Business',
    focus: 'Tecnología aplicada al negocio',
    description:
      'Productividad empresarial, soluciones corporativas de conectividad y dotación de accesorios de protección para flotas de equipos.',
  },
  {
    title: 'Franquicias en Venezuela',
    focus: 'Retail y expansión',
    description:
      'Casos de éxito, experiencia en tiendas tecnológicas, estandarización de operaciones e impacto de Canguro en la economía local.',
  },
  {
    title: 'Noticias TNO',
    focus: 'Cápsula informativa Tech',
    description:
      'Acontecer digital global (Apple, Samsung, Xiaomi) y cómo el mercado venezolano se adapta con el inventario de Canguro.',
  },
];

const metrics = [
  { value: '+90K', label: 'Seguidores TNO Network', subtitle: 'En todas sus redes' },
  { value: '8/mes', label: 'Artículos TNO Digest', subtitle: '2 por semana · SEO' },
];

const Alcance = () => {
  const theme = useTheme();

  return (
    <Box>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        gutterBottom
        color="primary"
        align="center"
      >
        Integración en programas clave
      </Typography>
      <Typography variant="h5" fontWeight={700} align="center" gutterBottom>
        Presencia orgánica y especializada
      </Typography>
      <Grid container spacing={3} sx={{ mt: 1, mb: 5 }}>
        {programs.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              component={Card}
              variant="outlined"
              height="100%"
              sx={{
                borderTop: 4,
                borderColor: theme.palette.primary.main,
              }}
            >
              <CardContent>
                <Typography variant="overline" color="primary" fontWeight={700}>
                  {item.focus}
                </Typography>
                <Typography variant="h6" fontWeight={700} gutterBottom>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.description}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        gutterBottom
        color="primary"
        align="center"
      >
        Alcance
      </Typography>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        {metrics.map((item, i) => (
          <Grid item xs={12} md={6} key={i}>
            <Box
              component={Card}
              variant="outlined"
              sx={{
                borderLeft: 4,
                borderColor: theme.palette.primary.main,
                height: '100%',
              }}
            >
              <CardContent>
                <Typography variant="h4" fontWeight={900} color="primary" gutterBottom>
                  {item.value}
                </Typography>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {item.label}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.subtitle}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Alcance;
